import { useTranslation } from 'react-i18next';
import './PercentRangeBar.scss';

/**
 * PercentRangeBar
 * Reusable horizontal bar showing a 0-100% scale with:
 * - Optional min/max shaded range
 * - Optional min/max markers
 * - Optional mean marker and label
 * - Optional current value marker and floating label
 *
 * Props expect PERCENT values (0-100) or null.
 */
export default function PercentRangeBar({ valuePct, meanPct, minPct, maxPct }) {
  const { t } = useTranslation();

  const showRange = minPct !== null && maxPct !== null;
  const showMin = minPct !== null;
  const showMax = maxPct !== null;
  const showMean = meanPct !== null;
  const showValue = !!valuePct;

  const currentLeft = `${showValue ? valuePct : 50}%`;

  return (
    <>
      <div className='delivery--brown-content-current-indicator'>
        <span className='delivery--brown-content-current-value' style={{ left: currentLeft }}>
          {showValue ? `${valuePct}%` : t('no_data')}
        </span>
      </div>
      <div className='delivery--brown-content-bar-container'>
        <div className='delivery--brown-content-bar'>
          {showRange && (
            <div
              className='delivery--brown-content-bar-gradient'
              style={{ left: `${minPct}%`, width: `${maxPct - minPct}%` }}
            ></div>
          )}
          {showMin && <div className='delivery--brown-content-marker' style={{ left: `${minPct}%` }}></div>}
          {showMean && <div className='delivery--brown-content-marker average' style={{ left: `${meanPct}%` }}></div>}
          {showMax && <div className='delivery--brown-content-marker' style={{ left: `${maxPct}%` }}></div>}
          {showValue && <div className='delivery--brown-content-current-marker' style={{ left: `${valuePct}%` }}></div>}
        </div>
        <div className='delivery--brown-content-labels'>
          <span style={{ left: '0%' }}>0%</span>
          {showMean && <span style={{ left: `${meanPct}%` }}>{meanPct}%</span>}
          <span style={{ left: '100%' }}>100%</span>
        </div>
      </div>
    </>
  );
}
